import { ExcessCombination } from '../../../../../state/configuration'

export const generateSlug = (excess: ExcessCombination): string =>
  Object.entries(excess)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, val]) => `${key}:${val}`)
    .join('|')
